import React, { useState, useEffect } from 'react';

const COLORS = ['#6366f1', '#ec4899', '#f59e0b', '#10b981', '#3b82f6', '#8b5cf6', '#ef4444', '#14b8a6', '#f97316'];

const getInitials = (name = '') =>
  name.trim().split(/\s+/).slice(0, 2).map(w => w[0]?.toUpperCase() || '').join('') || '?';

const colorFor = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return COLORS[Math.abs(h) % COLORS.length];
};

export const Avatar = ({ name = '', src, size = 40, className = '' }) => {
  const dim = { width: size, height: size };
  const resolvedSrc = src && src.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${src}` : src;
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [resolvedSrc]);

  if (resolvedSrc && !failed) {
    return (
      <img
        src={resolvedSrc}
        alt={name}
        style={dim}
        onError={() => setFailed(true)}
        className={`rounded-full object-cover shrink-0 bg-secondary ${className}`}
      />
    );
  }
  return (
    <div
      style={{ ...dim, backgroundColor: colorFor(name) }}
      className={`rounded-full flex items-center justify-center text-white font-semibold shrink-0 ${className}`}
      aria-label={name}
    >
      <span style={{ fontSize: size * 0.38 }}>{getInitials(name)}</span>
    </div>
  );
};

export default Avatar;
